import React from 'react';
import { motion } from 'framer-motion';
interface RevealOnScrollProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}
export function RevealOnScroll({
  children,
  delay = 0,
  className = ''
}: RevealOnScrollProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-40px'
  }} transition={{
    duration: 0.3,
    delay,
    ease: 'easeOut'
  }} className={className} data-id="element-184">
      {children}
    </motion.div>;
}